/**
* 基础菜单 商品管理
*/
<template>
  <div style="margin: 2%;">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/map_mn/Map_mn' }">地图管理</el-breadcrumb-item>
      <el-breadcrumb-item>线路管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.line_name" placeholder="输入线路名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.line_id" placeholder="输入线路编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addFormVisible = true"
          >导入数据</el-button
        > -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
      <el-table-column prop="id" fixed="left" align="center" label="ID" width="80">
      </el-table-column>
      <el-table-column prop="line_id" align="center" label="线路编号" width="250">
      </el-table-column>
      <el-table-column prop="line_name" align="center" label="线路名称" width="250">
      </el-table-column>
      <el-table-column prop="station_amount" align="center" label="站点数量" width="250">
      </el-table-column>
      <el-table-column prop="create_timer" align="center" label="创建时间" width="250">
      </el-table-column>
      <el-table-column prop="update_time" align="center" label="更新时间" width="250">
      </el-table-column>
      <el-table-column prop="" align="center" label="状态" width="150">
        <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </el-table-column>
      <el-table-column prop="remarks" align="center" label="备注" width="300">
      </el-table-column>

      <el-table-column align="center" fixed="right" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="addStation(scope.row)">站点管理</el-button>
          <el-button size="mini" @click="editFormVisible = true">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :visible.sync="editFormVisible" width="30%">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="线路编号" prop="line_id">
          <el-input size="small" v-model="editForm.map_name" auto-complete="off" :disabled="true" placeholder="请输入线路编号">
          </el-input>
        </el-form-item>
        <el-form-item label="线路名称" prop="line_name">
          <el-input size="small" v-model="editForm.map_name" auto-complete="off" :disabled="true" placeholder="请输入线路名称">
          </el-input>
        </el-form-item>
        <el-form-item label="站点数量" prop="station_amount">
          <el-input size="small" v-model="editForm.station_amount" auto-complete="off" :disabled="true"
            placeholder="请输入站点数量"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_timer">
          <el-input size="small" v-model="editForm.create_timer" auto-complete="off" :disabled="true"
            placeholder="请输入创建时间"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="update_time">
          <el-input size="small" v-model="editForm.update_time" auto-complete="off" :disabled="true"
            placeholder="请输入更新时间"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="">
          <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input size="small" type="textarea" v-model="editForm.remarks" auto-complete="off" placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "../../components/Pagination";
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        editFormVisible: false, //控制编辑页面显示与隐藏
        addFormVisible: false, //控制编辑页面显示与隐藏
        value: true,
        listData: [
          {
            id: "01",
            line_id: '01',
            line_name: "01",
            station_amount: '10',
            create_timer: "2022-01-01",
            update_time: "2022-01-01",
            remarks: "111111111",
          },
        ],
        
        editForm: {
          line_id: '',
          line_name: " ",
          station_amount: '',
          create_timer: " ",
          update_time: " ",
          remarks: " ",
        },
        // rules表单验证
        rules: {
          line_id: [
            { required: true, message: "请输入线路编号", trigger: "blur" },
          ],
          line_name: [{ required: true, message: "请输入线路名称", trigger: "blur" }],
          station_amount: [
            { required: true, message: "请输入站点数量", trigger: "blur" },
          ],
          create_timer: [{ required: true, message: "请输入创建时间", trigger: "blur" }],
          update_time: [
            { required: true, message: "请输入更新时间", trigger: "blur" },
          ],
          remarks: [{ required: true, message: "请输入备注", trigger: "blur" }],
        },
        formInline: {
          page: 1,
          limit: 10,
          pet_number: "",
          phone: "",
          token: localStorage.getItem("logintoken"),
        },
        // 删除部门
        seletedata: {
          ids: "",
          token: localStorage.getItem("logintoken"),
        },
        userparm: [], //搜索权限
        //   listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10,
        },
      };
    },
    // 注册组件
    components: {
      Pagination,
    },
    /**
     * 创建完毕
     */
    /*   created() {
      this.getdata(this.formInline);
    },
   */
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      //跳转到线路管理0
      addStation(row) {
        window.localStorage.setItem("area_id", row.id);
        this.$router.push("/map_mn/Station_mn");
      },
      // 获取公司列表
      
      // 删除公司
      deleteUser(index, row) {
        this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deptDelete(row.deptId)
              .then((res) => {
                if (res.success) {
                  this.$message({
                    type: "success",
                    message: "公司已删除!",
                  });
                  this.getdata(this.formInline);
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.$message.error("公司删除失败，请稍后再试！");
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false;
      },
    },
  };
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/map_mn/Line_mn.vue